import type { ReactNode } from 'react';

type Props = {
  label: string;
  right?: ReactNode;
  rightTone?: 'dim' | 'success';
  className?: string;
};

export function PanelLabel({ label, right, rightTone = 'dim', className }: Props) {
  return (
    <div className={`flex items-center justify-between gap-2${className ? ` ${className}` : ''}`}>
      <span className="font-mono text-[10px] leading-none tracking-[0.25em] text-fg-muted">
        {label}
      </span>
      {right != null && (
        <span
          className={`font-mono text-[10px] leading-none tracking-wider shrink-0 ${
            rightTone === 'success' ? 'text-success' : 'text-fg-dim'
          }`}
        >
          {right}
        </span>
      )}
    </div>
  );
}
